import { ThemeUICSSObject } from 'theme-ui';

export const linkStyles: ThemeUICSSObject = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 1,
  outline: '2px solid transparent',
  transition: 'all 0.1s ease-in-out',
  borderRadius: 'sm',
  outlineOffset: 8,
  textUnderlineOffset: 4,
  textDecoration: 'none',
  justifySelf: 'flex-start',
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  padding: 0,
  ':active': {
    color: 'blueScale.4',
  },
  ':focus:not(:active)': {
    outlineOffset: 4,
    outlineColor: 'blueScale.4',
  },
  ':hover': {
    textDecoration: 'underline',
    textDecorationThickness: 2,
  },
};
